module.exports = __webpack_public_path__ + "media/bootstrap-icons/window-dock-c69883a9.svg";